import React from 'react';
import { MapPin, Mail, Phone, Facebook, Instagram, Linkedin, Twitter, Youtube, ArrowUpRight } from 'lucide-react';
import { contact } from '../mock';

const Footer = () => {
  const cols = [
    { title: 'Company', links: ['About Us', 'Career', 'CSR', 'Gallery', 'Contact'] },
    { title: 'Services', links: ['CBG Plant', 'Bio-Diesel', 'Bio Ethanol', 'EcoSolar', 'EV Charging'] },
    { title: 'Resources', links: ['Blog', 'News & Events', 'Case Studies', 'Privacy Policy', 'Terms of Use'] },
  ];
  return (
    <footer className="bg-[#070f10] text-slate-300 relative overflow-hidden">
      <div className="absolute -top-20 -left-20 w-96 h-96 rounded-full bg-emerald-600/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <div className="inline-flex rounded-xl bg-white p-3 shadow-lg shadow-black/20">
            <img
              src="/assets/indian-energreen-logo-transparent.png"
              alt="Indian Energreen - Renewable Energy Solutions"
              className="h-16 sm:h-20 w-auto object-contain"
            />
          </div>
          <p className="mt-5 text-slate-400 leading-relaxed max-w-md">
            Fueling India's transition to a sustainable, energy-independent future with advanced biofuel, solar and EV charging solutions.
          </p>
          <div className="mt-6 space-y-3 text-sm">
            <a href={`mailto:${contact.email}`} className="flex items-center gap-3 hover:text-emerald-400 transition-colors"><Mail className="w-4 h-4 text-emerald-400" /> {contact.email}</a>
            <a href={`tel:${contact.phone1}`} className="flex items-center gap-3 hover:text-emerald-400 transition-colors"><Phone className="w-4 h-4 text-emerald-400" /> {contact.phone1}</a>
            <a href={contact.mapUrl} target="_blank" rel="noreferrer" className="flex items-start gap-3 hover:text-emerald-400 transition-colors"><MapPin className="w-4 h-4 text-emerald-400 mt-0.5" /> <span>{contact.address}</span></a>
          </div>
          <div className="mt-6 flex gap-2">
            {[Facebook, Instagram, Linkedin, Twitter, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-emerald-500 grid place-items-center transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="font-extrabold text-white text-lg">{c.title}</h4>
            <ul className="mt-5 space-y-3">
              {c.links.map((l) => (
                <li key={l}>
                  <a href="#" className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-emerald-400 hover:gap-2.5 transition-all">
                    <ArrowUpRight className="w-3.5 h-3.5" /> {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Indian Energreen. All rights reserved.</div>
          <div>Designed with <span className="text-emerald-400">♥</span> for a greener Bharat.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
